import React from 'react'
import classNames from "classnames";
import styles from "./FJUploadImage.module.less";
import InlineSVG from "react-inlinesvg";
import uploadIcon from "../../../icon/watermark_upload.svg";
import FJLocalStore from "../../../store/FJLocalStore";
import FJButton from 'fj-components/FJButton';
import FJInputFile from "fj-components/FJInputFile";

function Line() {
  return <div className={styles.line_box}/>
}

function FJUploadImage(props) {

  const {active, inputFile, onChange, acceptType, uploadBtnClick, onDragOver, onDragLeave, onDrop, dragFileMode} = props;

  return (
		<div className={classNames(styles.image_box, {[styles.active]: active})}
				 onDragOver={onDragOver}
				 onDragLeave={onDragLeave}
				 onDrop={onDrop}
		>
			{
				dragFileMode && (
					<div className={styles.shade}
							 onDragOver={onDragOver}
							 onDragLeave={onDragLeave}
							 onDrop={onDrop}
					/>
				)
			}
			<div className={styles.up_icon}>
				<InlineSVG src={uploadIcon}/>
			</div>
			<div className={styles.text_info}>
				{FJLocalStore._('up_watermark_image')}
			</div>
			<div className={styles.drop_or_box}>
				<Line />
				<div className={styles.or_box}>{FJLocalStore._('or')}</div>
				<Line />
			</div>
			<div className={styles.up_btn}>
				<FJButton text={FJLocalStore._('Browse Image')} className={styles.btn} onClick={uploadBtnClick}/>
				<FJInputFile ref={inputFile}
										 onChange={onChange}
										 multiple={false}
										 accept={acceptType}/>
			</div>
		</div>
  );
}

export default FJUploadImage;